export const dispatchToNative = (action) => {
    if (!window.ReactNativeWebView) {
        // We aren't in the native context
        return;
    }
    window.ReactNativeWebView.postMessage(JSON.stringify(action));
};
